var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Approval Logs")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "background-color": "#D0D3D4",
      "height": "1px"
    }
  }, [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Action By")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Action Date")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Action Type")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Action Comment")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Next Action By")])])])]), _vm._v(" "), _c('tbody', [(!_vm.getLogsList || _vm.getLogsList.length == 0) ? _c('tr', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('td', {
    attrs: {
      "colspan": 6
    }
  }, [_vm._v("No Records Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getLogsList), function(column, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(column.moduleactionby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.format_date(column.moduledate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(column.approvestatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(column.modulecomment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(column.modulenextactionby))])])
  })], 2)]), _c('br')])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c438e9","hasScoped":true}!./src/modules/clientmanagement/views/client/clientlisting/clienteview/clientlog/clientlog.component.html
// module id = 705
// module chunks = 3